import BlankLayout from '@/layouts/BlankLayout';
import type { RouteData } from '@/router/routes';
import { lazyWithReload } from '@/router/utils';

// Dropped from production builds.
export const devRoutes: RouteData[] = import.meta.env.DEV
  ? [
      {
        path: '/live-session-sandbox',
        component: lazyWithReload(() => import('@/routes/LiveSessionSandbox/LiveSessionSandbox')),
        layoutComponent: BlankLayout,
        getRoute: () => '/live-session-sandbox',
      },
    ]
  : [];
